export function convertDateToDateOnlyString(date: Date | undefined) {
    if (!date) {
        return "";
    }

    const month = date.getMonth() + 1;
    const monthString = month < 10 ? `0${month}` : month;
    const day = date.getDate();
    const dateString = day < 10 ? `0${day}` : day;

    return `${date.getFullYear()}-${monthString}-${dateString}`;
}

const tzOffset = new Date().getTimezoneOffset() * 60000;

export function convertDateOnlyStringToDate(dateString: string | undefined) {
    return dateString ? new Date(new Date(dateString).getTime() + tzOffset) : undefined;
}

export const isMonthAndYearBeforeToday = (month: number, year: number) => {
    const today = new Date();
    const currentMonth = today.getMonth();
    const currentYear = today.getFullYear();
    return year < currentYear || (year === currentYear && month < currentMonth + 1);
};
